import axios from 'axios';

const addReminder = (payload) => {
  return axios
    .post(`${process.env.REACT_APP_API_URL}/api/reminder`, payload)
    .then(res => res)
    .catch(err => err);
};

export default addReminder;
